export default __webpack_public_path__ + "static/media/full-bundle-accuchek-white@2x.1f55a03f.jpg";